// @system — Pricing page content (template defaults).
// Overwritten during template sync. Products override in @custom/pricing.js.
export default {
  title: 'Simple, transparent pricing',
  subtitle: 'Start free. Upgrade when you need more.',
  // {name} and {supportEmail} are filled in by PricingPage from the product's own brand, so the
  // default is never blank and never names the template. Products may override it in @custom/pricing.js.
  noPlansBody: '{name} has not published its plans yet. Write to {supportEmail} and we will send you a quote.',
}
